import { Center, Flex, HStack, Text, Tooltip } from '@chakra-ui/react';
import { i18n } from '../../../../shared/localization';
import { ChatGPTIcon } from '../ChatGPTIcon';

const { chatGPTToolTip } = i18n.pages.integrations.chatGPT;

export const ChatGPTToolTip = ({ boxSize }: { boxSize?: number }) => {
  return (
    <Flex data-testid="chat-gpt-tool-tip" alignItems="center">
      <Tooltip
        borderColor="yellow.200"
        border="1px solid"
        placement="bottom-end"
        data-testid="chatgpt-tooltip"
        label={
          <HStack
            data-testid="chat-gpt-tool-tip-icon-label"
            alignItems="flex-start"
          >
            <ChatGPTIcon boxSize={5} />
            <Text data-testid="chatgpt-tooltip-text">{chatGPTToolTip}</Text>
          </HStack>
        }
      >
        <Center data-testid="chat-gpt-tool-tip-icon-description">
          <ChatGPTIcon boxSize={boxSize ?? 5} />
        </Center>
      </Tooltip>
    </Flex>
  );
};
